import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const X: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--x')}
    viewBox="0 0 11 12"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g
      stroke="#F12626"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path d="M9.28 1.36l-7.737 9.22M1.543 1.36l7.736 9.22" />
    </g>
  </svg>
);

export default X;
